import { c as _c } from "react/compiler-runtime";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import { DropInteractionParams, DropLocation } from "../Drop";
import { ApiDrop } from "@/generated/models/ApiDrop";
import React from "react";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import OngoingParticipationDrop from "./OngoingParticipationDrop";
import EndedParticipationDrop from "./EndedParticipationDrop";
interface DefaultParticipationDropProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly showReplyAndQuote: boolean;
  readonly location: DropLocation;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly parentContainerRef?: React.RefObject<HTMLElement | null> | undefined;
}
export default function ParticipationDrop(props) {
  const $ = _c(4);
  const {
    drop
  } = props;
  const {
    isVotingEnded
  } = useDropInteractionRules(drop);
  if (isVotingEnded) {
    let t0;
    if ($[0] !== props) {
      t0 = <EndedParticipationDrop {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  } else {
    let t0;
    if ($[2] !== props) {
      t0 = <OngoingParticipationDrop {...props} />;
      $[2] = props;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
}